import { GET } from './../api';

export const getCompanyInformation = () => {
  return GET('/company', {
    company: localStorage.getItem('company')
  });
}
